import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle,
  Modal,
  ModalBody,
  Label,
} from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Utils from '../../Utility';
import { AvField, AvForm } from "availity-reactstrap-validation";
import Loader from "../../../components/Loader";
import DeleteModal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { get, post, put, upload } from '../../../helpers/api_helper'
import { toast } from 'react-toastify';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Multiselect from 'multiselect-react-dropdown'
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";

const Category = props => {
  const { user } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [file, setFile] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [cropperModal, setCropperModal] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [cats, setCats] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedLang, setSelectedLang] = useState([]);
  const imageInput = useRef();
  const cropper = useRef();


  useEffect(() => {
    if (user?.token) {
      getData();
    }
  }, [user]);

  useEffect(() => {
    get('/tags', { token: user?.token })
      .then(res => {
        setTags(res?.data);
      })
  }, []);

  useEffect(() => {
    if (!isAddForm) {
      setCurrentData(null);
      setSelectedLang([]);
    }
  }, [isAddForm]);

  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/know/intro", { token: user?.token })
        .then(res => {
          setLoading(false);
          if (res?.statusCode == 200) {
            setData(res?.data);
            setCurrentData(res?.data);
            setFile(res?.data?.image);
            if(res?.data?.alterLang)
              setSelectedLang(res?.data?.alterLang);
          } else
            toast.error(res?.error);
        })
        .catch(err => {
          toast.error('Something Went Wrong!');
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    setColumns([
      {
        name: "Position",
        cell: (row, index) => <>
          <Draggable key={row._id} draggableId={row._id} index={index}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <i className="mdi mdi-menu" style={{ fontSize: 20, color: Utils.themeColor }}></i>
              </div>
            )}
          </Draggable>
        </>,
        maxWidth: '50px'
      },
      {
        name: 'Title',
        selector: row => row.title,
      },
      {
        name: 'Tags',
        cell: row => <>
          {row?.tags?.map((item) => (
            <span>{item?.title}, </span>
          ))}
        </>,
        selector: row => row.tags,
      },
      {
        name: 'Questions',
        selector: row => row.question?.length,
        maxWidth: '120px'
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row)}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
        maxWidth: '110px'
      },
      user?.role == 'Admin' &&
      {
        cell: (row) => <>
          <Button onClick={() => handlePaid(row)}
            title={"Paid"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className={row?.isPaid ? "mdi mdi-currency-usd" : "mdi mdi-currency-usd-off"} style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleUpdateProj(row)}
            title={"Edit"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleDeleteProj(row)}
            title={"Delete"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        maxWidth: '150px'
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data, tags]);

  const handleValidSubmit = async (e, v) => {
    console.log('values', v);
    if (!file) {
      toast.error("Please select the intro image!");
      return;
    }
    let body = {
      ...v,
      image: file,
      alterLang: selectedLang,
      token: user?.token
    }
    if (file.substring(0, 4) == 'data') {
      const obj = await urltoFile(file, new Date().getTime() + '.png', 'image/png');
      const temp = await resizeFile(obj);
      const form = new FormData();
      form.append("image", temp);
      const imageRes = await upload("/know/image_upload", form);
      body.image = imageRes?.data;
    }
    setLoading(true);
    put("/know/intro", body)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          getData();
          setIsAddForm(false);
        } else {
          toast.error(res?.error);
        }
      })
      .catch(err => {
        toast.error(err);
        setLoading(false);
      })
  }

  const handleUpdateProj = (row) => {
    setCurrentData(row);
    let tempTags = [];
    tags?.forEach((item) => {
      row?.tags?.forEach((tag) => {
        if (item?._id == tag?._id)
          tempTags.push(item);
      })
    });
    setSelectedTags(tempTags);
    if (row?.alterLang?.length)
      setSelectedLang(row?.alterLang);
    setIsAddForm(true);
  }

  const handleUpdateStatus = (row) => {
    setCurrentData({ ...row, actionType: 'Status' });
    setDeleteModal(true);
  }

  const handleDeleteProj = (proj) => {
    setCurrentData(proj);
    setDeleteModal(true);
  }

  const onStatus = () => {
    // console.log('status', currentModalData);
    setLoading(true);
    let body = {
      catId: currentData?._id,
      isActive: !currentData?.isActive,
      token: user?.token
    }
    let url = `/know/cat`;
    put(url, body)
      .then(json => {
        console.log('response from delete user', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const onDelete = () => {
    setLoading(true);
    let body = {
      catId: currentData?._id,
      token: user?.token
    }
    let url = `/know/cat`;
    if (currentData?.actionType == 'Paid') {
      body = { ...body, isPaid: !currentData?.isPaid };
    } else {
      body = { ...body, isDeleted: true };
    }
    put(url, body)
      .then(json => {
        console.log('response from delete user', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const cropImage = (e, v) => {
    setLoading(true);
    const fileData = cropper?.current?.cropper?.getCroppedCanvas().toDataURL();
    setFile(fileData);
    setCropperModal(false);
    setLoading(false);
  }

  const urltoFile = (url, filename, mimeType) => {
    return (fetch(url)
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
  }

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1080,
        1920,
        "webp",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });


  const handlePaid = (row) => {
    setCurrentData({ ...row, actionType: "Paid" });
    setDeleteModal(true);
  }

  const handleSelectLang = (code, lang) => {
    let temp = Object.assign([], selectedLang);
    let already = temp.findIndex(x => x.code == code);
    if (already == -1) {
      temp.push({ code: code, title: "", lang });
    } else {
      temp.splice(already, 1);
    }
    // console.log("temp", temp);
    setSelectedLang(temp);
  }

  const handleAlterTitle = (index, key, val) => {
    let temp = Object.assign([], selectedLang);
    temp[index][key] = val;
    setSelectedLang(temp);
  }

  const onChangeFile = async (e, type) => {
    setCurrentFile(URL.createObjectURL(e.target.files[0]));
    setCropperModal(true);
  }

  const removeImage = (to, i) => {
    setFile(null);
    setCurrentFile(null);
  }
  // console.log('image changed', image);

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Know yourself Introduction" />
        {/* Image cropper modal */}
        <Modal isOpen={cropperModal} centered={true}>
          <ModalBody className="py-3 px-5">
            <h5 className="text-black font-size-20">Crop Image</h5>
            <div className="p-2">
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  cropImage()
                }}
              >
                <div className="mb-3 mt-2">
                  <Row>
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        style={{ backgroundColor: Utils.themeColor, border: "none" }}
                        onClick={() => { setCropperModal(false) }}
                        type="reset"
                      >
                        Cancel
                      </button>
                    </Col>
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        type="submit"
                        style={{ backgroundColor: Utils.themeColor, border: "none" }}
                      >
                        Submit
                      </button>
                    </Col>
                  </Row>
                </div>
                <div className="mt-4">
                  <Cropper
                    style={{ height: 'auto', width: 400 }}
                    aspectRatio={1 / 1}
                    preview=".img-preview"
                    guides={true}
                    src={currentFile}
                    ref={cropper}
                  />
                </div>
              </AvForm>
            </div>
          </ModalBody>
        </Modal>
        <Card>
          <CardBody>
            <Row>
              <DeleteModal
                show={deleteModal}
                onDeleteClick={() => currentData?.actionType == 'Status' ? onStatus() : onDelete()}
                onCloseClick={() => setDeleteModal(false)}
                actionType={currentData?.actionType}
                data={currentData}
              />
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                      <div>
                        <CardTitle className="h4">Introduction</CardTitle>
                        <CardSubtitle className="mb-3">
                          Introduction you have added before. will show up whenever a test start.
                        </CardSubtitle>
                      </div>
                      {/* {user?.role == 'Admin' &&
                        <div className="text-center" style={{ marginLeft: 'auto' }}>
                          <Button style={{ backgroundColor: Utils.themeColor, border: 'none' }} onClick={() => setIsAddForm(true)}>
                            Add
                          </Button>
                        </div>
                      } */}
                    </div>
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v, 'bank')
                      }}
                    >
                      <Row>
                        <Col md={3} className="mb-4">
                          {file ?
                            <Col md={12} style={{ marginRight: '2rem' }}>
                              <div className="me-3 position-relative" style={{ width: 216, height: 216 }}>
                                <img
                                  src={file ? file : avatar}
                                  alt=""
                                  style={{ width: '100%', height: '100%' }}
                                />
                                <div style={{ position: 'absolute', height: 40, width: 40, right: -20, top: -20, paddingTop: 5, backgroundColor: Utils.themeColor, borderRadius: 50, textAlignLast: 'center', cursor: 'pointer' }}
                                  onClick={(e) => removeImage()}
                                >
                                  <i className="mdi mdi-close" style={{ color: 'white', fontSize: 22 }} />
                                </div>
                              </div>
                            </Col>
                            :
                            <Col md={12}>
                              <div className="me-3 position-relative" style={{ width: 216, height: 216 }}>
                                <div className='image_placeholder' style={{ width: '100%', height: '100%' }}
                                  onClick={(e) => imageInput.current.click(e)}
                                >
                                  <button type="button" style={{ backgroundColor: Utils.themeColor, borderRadius: 5, color: '#fff', padding: '5px 10px', border: 'none' }}> + Add Banner</button>
                                  <div style={{ position: 'absolute', height: 40, width: 40, right: -20, top: -20, paddingTop: 5, backgroundColor: Utils.themeColor, borderRadius: 50, textAlignLast: 'center', cursor: 'pointer' }}
                                  >
                                    <i className="mdi mdi-camera-outline" style={{ color: 'white', fontSize: 22 }} />
                                  </div>
                                  <input type="file" id="file"
                                    ref={imageInput}
                                    // accept='image/*'
                                    onChange={(e) => onChangeFile(e, 'file')}
                                    style={{ display: "none" }} />
                                </div>
                              </div>
                            </Col>
                          }
                        </Col>
                        <Col lg={9} md={9}>
                          <div className="mb-3">
                            <AvField
                              name="desc"
                              label="Description *"
                              placeholder="Enter introduction for the know yourself"
                              className="form-control"
                              type="textarea"
                              rows={8}
                              value={currentData?.desc}
                              required
                            />
                          </div>
                        </Col>
                      </Row>
                      <Label>Alternative Languages</Label>
                      <Row>
                        <div className='lang-checks mb-3'>
                          {user?.languages?.map((item) => (
                            <div className='check-group'>
                              <label for={item?.title} class="container">
                                {item?.title}
                                <input type="checkbox" name={item?.title} id={item?.title} checked={selectedLang.findIndex(x => x?.code == item?.code) != -1} onChange={(e) => handleSelectLang(item?.code, item?.title)} />
                                <span class="checkmark"></span>
                              </label>
                            </div>
                          ))}
                        </div>
                        {selectedLang?.map((item, index) => (
                          <Row>
                            <Col md={12}>
                              <div className="mb-3">
                                <AvField
                                  name={"desc" + item?.lang}
                                  label={"Description in " + item?.lang}
                                  className="form-control"
                                  placeholder={"Enter description in " + item?.lang}
                                  type="textarea"
                                  rows={4}
                                  onChange={(e) => handleAlterTitle(index, "desc", e.target.value)}
                                  required
                                  value={item?.desc}
                                />
                              </div>
                            </Col>
                          </Row>
                        ))}
                      </Row>
                      <div className="mt-4 w-100 d-flex justify-content-end">
                        <button
                          className="btn btn-primary w-25 waves-effect waves-light"
                          type="submit"
                          style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                        >
                          {'Update'}
                        </button>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <audio id="audio" src={currentAudio} />
      </div>
    </React.Fragment>
  )
}


const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, {})(Category)
)